export default "__VITE_ASSET__DFGB4HwT__"